export default __webpack_public_path__ + "static/image 62-da6330d9e8d47b58c9a8d34a2a824f4e.png";